import React from 'react';
import {
	ApButtonTab,
	ApSecondaryNav,
	colors,
} from '@alixpartners/ui-components';

// import CurrencyUnitsSelect from '../Details/CurrencyUnitsSelect';
import YearsSelect from '../Details/YearsSelect';
import CompanySelect from '../Details/CompanySelect';
// import DimensionSelect from '../Details/DimensionSelect';
import MoreFilters from './MoreFilters';
import SearchDialog from './SearchDialog';

import { useLocation, NavLink } from 'react-router-dom';
import {
	PageToolbarControls,
	RightAlignBox,
	BackButtonWrapper,
	TransactionsTitle,
	ButtonIcon,
} from './SecondaryNav.styles';
import CompaniesSelect from 'Details/CompaniesSelect';

const PMI_NAV_CONFIG = [
	{
		path: '/pmi/spend',
		title: 'Spend',
	},
	{
		path: '/pmi/explore',
		title: 'Table',
	},
];

export const BASELINE_NAV_CONFIG = [
	{
		path: '/spend',
		name: 'spend',
		label: 'Investigate',
	},
	{
		path: '/taxonomymapper',
		name: 'taxonomy-mapper',
		label: 'Taxonomy Mapper',
	},
	{
		path: '/spend/explore',
		name: 'transactions',
		label: 'Transactions',
	},
	{
		path: '/spend/pivot-table',
		name: 'pivot-table',
		label: 'Slice & Dice',
	},
];

export const SecondaryNav = ({
	disableYearsSelect,
	disableDimensions,
	disableNegativeSpendSelect,
	transactionsTitle,
	onBackButtonClick,
	showPMINav,
	companiesList,
	isBenchamarks,
}) => {
	const location = useLocation();
	const FiltersComponent = showPMINav
		? PMIFilters
		: isBenchamarks
			? BenchmarksFilters
			: Filters;

	return (
		<ApSecondaryNav
			zIndex={3}
			left={
				transactionsTitle ? (
					<BackButtonWrapper>
						<ButtonIcon
							iconName="baseline_arrow_back"
							iconProps={{ iconColor: colors.grey8 }}
							onClick={onBackButtonClick}
						/>
						<TransactionsTitle>{transactionsTitle}</TransactionsTitle>
					</BackButtonWrapper>
				) : showPMINav ? (
					<React.Fragment>
						{PMI_NAV_CONFIG.map(({ path, title }) => (
							<NavLink to={path} key={path}>
								<ApButtonTab isSelected={location.pathname.includes(path)}>
									{title}
								</ApButtonTab>
							</NavLink>
						))}
					</React.Fragment>
				) : (
					<React.Fragment>
						{BASELINE_NAV_CONFIG.map(({ path, label }) => (
							<NavLink to={path} key={path}>
								<ApButtonTab isSelected={location.pathname === path}>
									{label}
								</ApButtonTab>
							</NavLink>
						))}
					</React.Fragment>
				)
			}
			right={
				<FiltersComponent
					disableYearsSelect={disableYearsSelect}
					disableDimensions={disableDimensions}
					disableNegativeSpendSelect={disableNegativeSpendSelect}
					companiesList={companiesList}
				/>
			}
		/>
	);
};

export const Filters = ({
	isOpportunities,
	// disableDimensions,
	disableYearsSelect,
	disableNegativeSpendSelect,
}) => {
	return (
		<PageToolbarControls fullWidth>
			<RightAlignBox>
				{/* <DimensionSelect shouldDisableOption={disableDimensions} /> */}
				<YearsSelect disabled={disableYearsSelect} />
				{/* <CurrencyUnitsSelect /> */}
				<MoreFilters
					isOpportunities={isOpportunities}
					disableNegativeSpendSelect={disableNegativeSpendSelect}
				/>
				<SearchDialog />
			</RightAlignBox>
		</PageToolbarControls>
	);
};

export const PMIFilters = ({
	isOpportunities,
	disableYearsSelect,
	disableNegativeSpendSelect,
	companiesList,
}) => {
	return (
		<PageToolbarControls fullWidth>
			<RightAlignBox>
				{companiesList && <CompaniesSelect data={companiesList} />}
				<YearsSelect disabled={disableYearsSelect} />
				<MoreFilters
					isOpportunities={isOpportunities}
					disableNegativeSpendSelect={disableNegativeSpendSelect}
					hideHarmonizedVendorsSelect
				/>
				<SearchDialog isPmi />
			</RightAlignBox>
		</PageToolbarControls>
	);
};

export const BenchmarksFilters = ({ disableYearsSelect }) => {
	return (
		<PageToolbarControls fullWidth>
			<RightAlignBox>
				<CompanySelect />
				<YearsSelect disabled={disableYearsSelect} />
			</RightAlignBox>
		</PageToolbarControls>
	);
};

export default SecondaryNav;
